export default "__VITE_ASSET__DB39T$Dy__"